'use client';
import React from 'react';
import { useInView } from 'react-intersection-observer';

const FadeInOnScroll = ({ children, delay = 0 }) => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Animate only once
    threshold: 0.1, // Trigger when 10% of the element is visible
  });

  const animationClasses = `transition-all duration-700 ease-out`;
  const initialState = 'opacity-0 translate-y-5';
  const finalState = 'opacity-100 translate-y-0';

  return (
    <div
      ref={ref}
      className={`${animationClasses} ${inView ? finalState : initialState}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

export default FadeInOnScroll;
